import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaLogs } from '../../components/TabelaLogs';

export default function LogsPage() {

    return (
        <>           
            <MenuMain >
                <TabelaLogs />
            </MenuMain>
            <AppFooter />    
        </>
    );
}